module.exports = __webpack_public_path__ + "media/application/images/2023/shapes/01_shape-md-8b298c14febaa9982efcd4d7f60c78cc.png";